import React, { useState } from 'react'
import { Card, Col, Flex, Row } from 'antd'
import { ModuleTopHeading, ServiceTable } from '../../components';


const ServicePage = () => {

    const [ visible, setVisible] = useState(false)
    
   
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading 
                                level={4} 
                                name='Services'
                                onClick={()=>setVisible(true)}
                            />
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <ServiceTable 
                            visible={visible}
                            setVisible={setVisible}
                        />
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { ServicePage }
